import { useEffect, useState } from "react";
import axios from "axios";
import { toast } from "sonner";
import { API, authHeaders, errorText } from "@/lib/api";
import { CrmCells } from "./AdminCrm";

const TONE = { ready: "bg-teal-50 text-teal-800", generating: "bg-sky-50 text-sky-800", failed: "bg-red-50 text-red-700" };

export const ResumeLeadsTable = () => {
  const [rows, setRows] = useState([]);
  useEffect(() => {
    axios.get(`${API}/admin/resume-leads`, { headers: authHeaders() })
      .then((r) => setRows(Array.isArray(r.data) ? r.data : []))
      .catch((e) => toast.error(errorText(e)));
  }, []);
  return (
    <div className="overflow-x-auto rounded-xl border border-slate-200 bg-white">
      <table data-testid="admin-resume-table" className="w-full min-w-[1100px] text-left text-[14px]">
        <thead className="bg-slate-50 text-[12px] uppercase tracking-wider text-slate-600">
          <tr>{["Date", "Lead", "Target role", "Result", "ATS estimate", "Emails", "Status", "Notes"].map((h) => <th key={h} className="px-4 py-3 font-semibold">{h}</th>)}</tr>
        </thead>
        <tbody className="divide-y divide-slate-100">
          {rows.map((r) => (
            <tr key={r.id} data-testid="admin-resume-row">
              <td className="px-4 py-3 text-slate-600">{new Date(r.created_at).toLocaleString()}</td>
              <td className="px-4 py-3"><p className="font-semibold text-[#0B1B33]">{r.name}</p><p className="text-slate-600">{r.email}</p></td>
              <td className="px-4 py-3">{r.target_role}</td>
              <td className="px-4 py-3">
                <span className={`rounded-full px-2.5 py-1 text-[12px] font-semibold ${TONE[r.status] || ""}`}>{r.status}</span>
                {r.downloads && <div className="mt-2 flex gap-2 text-[13px] font-semibold text-[#0E9384]">
                  <a href={r.downloads.pdf} target="_blank" rel="noreferrer" className="underline" data-testid="admin-resume-pdf">PDF</a>
                  <a href={r.downloads.docx} className="underline" data-testid="admin-resume-docx">DOCX</a></div>}
              </td>
              <td className="px-4 py-3">{r.ats_after != null ? `${r.ats_before} → ${r.ats_after}` : "-"}</td>
              <td className="px-4 py-3 text-[12px] text-slate-600">User: {r.user_email || "-"}<br />Admin: {r.admin_email || "-"}</td>
              <CrmCells email={r.email} name={r.name} />
            </tr>
          ))}
          {!rows.length && <tr><td colSpan={8} className="px-4 py-12 text-center text-slate-600">No Resume Studio requests yet.</td></tr>}
        </tbody>
      </table>
    </div>
  );
};
